import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';
import { getYoutubePreviewImage, YOUTUBE_PREVIEW_SIZE } from 'client/utils/image-helpers';
import { EmbeddedYoutube } from 'site-modules/shared/components/video/embedded-youtube/embedded-youtube';
import { Link } from 'site-modules/shared/components/link/link';

export function VideosGrid({ entry }) {
  const { title } = entry;
  const moreLink = entry.metadata('moreLink').value();
  const moreLinkText = entry.metadata('moreLinkText').value();

  return (
    <div className="videos-grid mb-3_5 mb-md-0">
      <h2 className="heading-3 mb-1_5">{title}</h2>
      <Row>
        {entry.children().map(videoEntry => {
          const videoId = videoEntry.metadata('videoId').value();
          const videoTitle = videoEntry.metadata('videoTitle').value();
          const thumbnailSrc = getYoutubePreviewImage(videoId, YOUTUBE_PREVIEW_SIZE.MQ);

          return (
            <Col key={videoId} xs={12} md={6} className="mb-1_5">
              <EmbeddedYoutube
                videoId={videoId}
                videoTitle={videoTitle}
                creativeId={`video-${videoId}`}
                thumbnailSrc={thumbnailSrc}
              />
              <div className="text-gray-darker mt-0_25">{videoTitle}</div>
            </Col>
          );
        })}
      </Row>
      {!!moreLink && (
        <Link to={moreLink} target="_blank" className="text-primary-darker">
          {moreLinkText}
          <i className="d-inline-block icon-arrow-right4 size-10 ms-0_25" aria-hidden />
        </Link>
      )}
    </div>
  );
}

VideosGrid.propTypes = {
  entry: CmsEntities.Content.isRequired,
};
